export enum CoreSensorType {
  OB1 = 'ob1',
  S5B = 's5b',
  S5 = 's5',
  R60 = 'r60',
  R56 = 'r56',
  VIRTUAL = 'virtual',
}
export enum CoreSensorStatus {
  ONLINE = 'online',
  PROVISIONING = 'provisioning',
  ERROR = 'error',
  UNCONFIGURED = 'unconfigured',
  LOW_POWER = 'low_power',
}

export type CoreSensorNetworkAddress = {
  if?: string;
  mac?: string;
  family?: string;
  address?: string;
};

// Sensor data returned by GET /v2/sensors
export type CoreSensor = {
  serial_number: string;
  uuid: string | null;
  organization_id: string;
  doorway_id: string | null;
  doorway_name: string | null;
  sensor_type: CoreSensorType;
  status: CoreSensorStatus;
  last_heartbeat: string | null;
  current_disposition: string | null;
  network_addresses: Array<CoreSensorNetworkAddress>;
  firmware_version: string | null;
  created_at: string;
  updated_at: string;
};
